import type { Player } from '../types';
import { Group, Rect, Text, Circle } from 'react-konva';

interface PlayerSeatProps {
  player: Player | null | undefined;
  isTurn: boolean;
  position: 'top' | 'right' | 'bottom' | 'left';
  x: number;
  y: number;
}

export function PlayerSeat({ player, isTurn, position, x, y }: PlayerSeatProps) {
  const isAi = player?.isAI;
  const name = player?.name || (isAi ? 'AI' : '等待中...');
  const cardCount = player?.hand?.length || 0;
  const passed = player?.passed;

  return (
    <Group x={x} y={y}>
      {isTurn && (
        <Circle
          x={0}
          y={0}
          radius={50}
          stroke="#ffd700"
          strokeWidth={3}
          dash={[10, 5]}
        />
      )}
      
      <Rect
        x={-60}
        y={-30}
        width={120}
        height={60}
        fill={isTurn ? '#ffeb3b' : '#fff'}
        stroke={isTurn ? '#f39c12' : '#ddd'}
        strokeWidth={isTurn ? 2 : 1}
        cornerRadius={8}
        shadowColor="black"
        shadowBlur={5}
        shadowOpacity={0.2}
      />
      
      <Text
        x={-50}
        y={-15}
        text={name}
        fontSize={16}
        fontStyle="bold"
        fill="#333"
        width={100}
        align="center"
      />
      
      <Text
        x={-50}
        y={5}
        text={`${cardCount} 张`}
        fontSize={12}
        fill="#666"
        width={100}
        align="center"
      />

      {passed && (
        <Text
          x={-30}
          y={25}
          text="已放弃"
          fontSize={12}
          fill="#999"
        />
      )}

      {isAi && player?.aiDifficulty && (
        <Text
          x={30}
          y={-20}
          text={`(${player.aiDifficulty})`}
          fontSize={10}
          fill="#888"
        />
      )}
    </Group>
  );
}